import { createAction, props } from '@ngrx/store';

// Action to create or update workspace fields
export const createOrUpdateWorkspaceFields = createAction(
  '[Workspace] Create/Update Workspace Fields',
  props<{ fields: any }>()
);
